import Moment from 'moment';
import { extendMoment } from 'moment-range';
import Vue from 'vue';
import { formatAnalyticSummary } from './home/chartFormatHelpers';
import { getAll, graphQL } from '../../api';
import {
  getAllScreenItems,
  getScreensByGroup,
} from '../../api/modules/screenStats';

const moment = extendMoment(Moment);
// initial users state
const state = {
  graphLoadingStates: {
    featureUsage: true,
    appUsage: true,
    roundsPlayed: true,
    launchModes: true,
    networkHealth: true,
    carOverview: true,
    launchModeData: true,
  },
  homeData: {},
  userData: {
    lineCharts: [
      {
        chartType: 'line',
        showOnMobile: true,
        type: 'line-chart',
        component: 'chart',
        width: '100%',
        title: '',
        data: [],
        labels: [],
        secondaryTitle: null,
        options: null,
      },
      {
        chartType: 'line',
        showOnMobile: true,
        type: 'line-chart',
        component: 'chart',
        width: '100%',
        title: '',
        data: [],
        labels: [],
        secondaryTitle: null,
        options: null,
      },
      {
        chartType: 'line',
        showOnMobile: true,
        type: 'line-chart',
        component: 'chart',
        width: '100%',
        title: '',
        data: [],
        labels: [],
        secondaryTitle: null,
        options: null,
      },
    ],
    homePage: [
      {
        component: 'NetworkHealth',
        showOnMobile: null,
      },
      {
        component: 'ScreensOverview',
        showOnMobile: null,
      },
      {
        component: 'FeatureUsage',
        title: 'Feature Usage',
        showOnMobile: null,
      },
      {
        component: 'AppUsage',
        title: 'App Usage',
        showOnMobile: null,
      },
      {
        component: 'Ratings',
        showOnMobile: null,
        width: '100%',
      },
      {
        component: 'DeviceMap',
        showOnMobile: false,
      },
    ],
  },
  ratingData: {
    total: 0,
    avg: 0,
    votesPerRating: [
      { rating: 1, amount: 0 },
      { rating: 2, amount: 0 },
      { rating: 3, amount: 0 },
      { rating: 4, amount: 0 },
      { rating: 5, amount: 0 },
    ],
  },
  oneWayVsRoundTrip: {
    data: [0, 0],
    labels: ['1-way', 'Round Trip'],
  },
  networkHealth: {
    data: [0, 0, 0],
    labels: ['Good', 'OK', 'Bad'],
    options: { colors: ['#0CFB92', '#FFC100', '#FD0040'] },
  },
  carOverview: {
    data: [0, 0],
    labels: ['In Use', 'Idle'],
    options: { colors: ['#607D8B', '#1F1E34'] },
  },
  locations: [],
  yAxis: [
    {
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#008FFB',
      },
      labels: {
        style: {
          colors: '#008FFB',
        },
      },
      title: {
        text: 'Total Clicks',
        style: {
          color: '#008FFB',
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    {
      seriesName: 'Average Duration (Minutes)',
      opposite: true,
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#FFC103',
      },
      labels: {
        style: {
          colors: '#FFC103',
        },
      },
      title: {
        text: 'Average Duration (Minutes)',
        style: {
          color: '#FFC103',
        },
      },
    },
    {
      seriesName: 'Total Duration (Minutes)',
      opposite: true,
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#00E396',
      },
      labels: {
        style: {
          colors: '#00E396',
        },
      },
      title: {
        text: 'Total Duration (Minutes)',
        style: {
          color: '#00E396',
        },
      },
    },
  ],
};

// getters
const getters = {
  getUserData: state => state.userData,
  getUsageData: state => state.usageData,
  getRatingData: state => {
    state.ratingData.votesPerRating.reverse();
    return state.ratingData;
  },
  getMapData: state => state.mapData,
  getAppUsageData: state => state.appUsageData,
  getOneWayVsRoundTrip: state => state.oneWayVsRoundTrip,
  getNetworkHealth: state => state.networkHealth,
  getLocations: state => state.locations,
  getCarOverview: state => state.carOverview,
  getGraphLoadingStates: state => state.graphLoadingStates,
};

// actions
const actions = {
  getHomePageData: async ({ rootGetters, dispatch, commit }, payload) => {
    commit('loading/setLoading', true, { root: true });
    const homeFilter = rootGetters['filters/getFilter'];
    let filterVariables = {};
    let variables = {};
    let sdate = moment()
      .day(0)
      .format('X');
    let edate = moment()
      .day(6)
      .format('X');
    const userGroups =
      rootGetters['account/getCurrentUser'].group_id &&
      rootGetters['account/getCurrentUser'].group_id[0];

    if (userGroups && userGroups !== 'all') {
      variables.group_id = userGroups;
    } else if (homeFilter.group !== undefined && homeFilter.group !== '') {
      variables.group_id = homeFilter.group;
    }

    if (homeFilter.area !== undefined && homeFilter.area !== '') {
      variables.area_id = homeFilter.area;
    }
    if (homeFilter.city !== undefined && homeFilter.city !== '') {
      variables.city = homeFilter.city;
      filterVariables.city = homeFilter.city;
    }
    if (
      homeFilter.start_date !== '' &&
      homeFilter.start_date !== undefined &&
      homeFilter.end_date !== '' &&
      homeFilter.end_date !== undefined
    ) {
      sdate = moment
        .utc(homeFilter.start_date)
        .local()
        .format('X');
      edate = moment
        .utc(homeFilter.end_date)
        .local()
        .format('X');
    }
    let indexType = 'all';
    if (variables.area_id) {
      indexType = 'area';
    } else if (variables.group_id) {
      indexType = 'group';
    }
    variables = JSON.stringify(variables).replace(/"([^"]+)":/g, '$1: ');
    filterVariables = JSON.stringify(filterVariables).replace(
      /"([^"]+)":/g,
      '$1: '
    );
    // state.userData.lineCharts = [];
    const filterParams = {
      indexType,
      variables,
      filterVariables,
      sdate,
      edate,
    };
    dispatch('maps/getDeviceLocations', payload, { root: true });
    if (payload.client_name === 'shark') {
      dispatch('account/getSharkClientGroups', {
        filterParams,
        homeFilter,
        name: payload.client_name,
        table_name: payload.table_name
      }, { root: true });
    }
    if (payload.client_name !== 'shark') {
      Vue.set(state.userData.homePage, 1, {
        component: 'OneWayRoundTrip',
        showOnMobile: null,
      });
      dispatch('getForecastedData', {
        filterParams,
        homeFilter,
        name: payload.client_name,
        table_name: payload.table_name,
      });
      dispatch('getUniqueRentalData', {
        filterParams,
        homeFilter,
        name: payload.client_name,
        table_name: payload.table_name,
      });
      dispatch('getOneWayVsRoundTripData', {
        filterParams,
        homeFilter,
        table_name: payload.table_name,
        client_name: payload.client_name,
      });
      dispatch('getScreenStatusData', {
        filterParams,
        homeFilter,
        table_name: payload.table_name,
      });
      dispatch('getAnalyticsScreens', {
        filterParams,
        homeFilter,
        table_name: payload.table_name,
        client_name: payload.client_name,
      });
    }
    if (payload.client_name === 'shark') {
      Vue.set(state.userData.homePage, 1, {
        component: 'CarOverview',
        showOnMobile: null,
      });
      dispatch('getTotalCarsChart', {
        filterParams,
      });
      dispatch('getLaunchModeChart', {
        filterParams,
        homeFilter,
        name: payload.client_name,
      });
      dispatch('getLaunchModeScreens', {
        filterParams,
        homeFilter,
        name: payload.client_name,
      });
      dispatch('getRoundsPlayedChart', {
        filterParams,
        homeFilter,
        name: payload.client_name,
      });
      dispatch('getAnalyticsGraphs', {
        filterParams,
        homeFilter,
        client_name: payload.client_name,
      });
      dispatch('getNetworkHealthGraph', {
        filterParams,
        homeFilter,
        client_name: payload.client_name,
      });
      dispatch('getCarOverview', {
        filterParams,
        homeFilter,
        client_name: payload.client_name,
      });
    }
    dispatch('getRatingsData', {
      filterParams,
      homeFilter,
      table_name: payload.table_name,
    });
    dispatch('getHomeLocations', {
      filterParams,
      homeFilter,
      table_name: payload.table_name,
    });
  },
  getTotalCarsChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'carOverview', value: true });
    graphQL({
      query: `
        query {
          getTotalCarGraph(
            sdate: ${payload.filterParams.sdate}, 
            edate: ${payload.filterParams.edate}, 
            filter: ${payload.filterParams.variables}
          ){
            data
            labels
          }
        }
      `,
    })
      .then(res => {
        const data = res.data.data.getTotalCarGraph;
        const chart = {
          chartType: 'line',
          showOnMobile: true,
          type: 'line-chart',
          component: 'chart',
          width: '100%',
          title: 'Active Golf Cars',
          data: [{ data: data.data, title: 'Total Active Golf Cars' }],
          labels: data.labels,
        };

        commit('setCartData', chart);
        commit('setGraphLoadingState', {
          name: 'totalCars',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getCarOverview: async ({ commit }, payload) => new Promise((resolve, reject) => {
    graphQL({
      query: `
        query {
          getCarOverviewGraph (sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables}){
            in_use
            idle
          }
        }`,
    })
      .then(res => {
        commit('setCarOverview', res.data.data.getCarOverviewGraph);
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getUniqueRentalData: async ({ commit }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/session?query=${encodeURIComponent(
        `{get(type_name: "session", 
            sdate: ${payload.filterParams.sdate},
            edate: ${payload.filterParams.edate},
            session: ${payload.filterParams.variables}, 
            filters: ${payload.filterParams.filterVariables}, 
            table_name:"${payload.table_name}",
            index: "${payload.filterParams.indexType}-index"
          ){
            uuid,
            trip_type,
            start_at,
            end_at,
            expected_end_at
          }}`
      )}`
    )
      .then(res => {
        commit('setLineGraphData', {
          data: res.data,
          filter: payload.homeFilter,
          client: payload.name,
          type: 'unique',
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getForecastedData: async ({ commit }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/session?query=${encodeURIComponent(
        `{get(type_name: "session", 
            sdate: ${payload.filterParams.sdate},
            edate: ${payload.filterParams.edate},
            session: ${payload.filterParams.variables}, 
            filters: ${payload.filterParams.filterVariables}, 
            table_name:"${payload.table_name}",
            index: "${payload.filterParams.indexType}-index"
          ){
            uuid,
            trip_type,
            start_at,
            end_at,
            expected_end_at
          }}`
      )}`
    )
      .then(res => {
        commit('setLineGraphData', {
          data: res.data,
          filter: payload.homeFilter,
          client: payload.name,
          type: 'forecastedDays',
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getOneWayVsRoundTripData: async ({ commit }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/session?query=${encodeURIComponent(
        `{get(type_name: "session", 
            sdate: ${payload.filterParams.sdate},
            edate: ${payload.filterParams.edate},
            session: ${payload.filterParams.variables}, 
            filters: ${payload.filterParams.filterVariables}, 
            table_name:"${payload.table_name}",
            index: "${payload.filterParams.indexType}-index"
          ){,
            uuid,
            trip_type
          }}`
      )}`
    )
      .then(res => {
        commit('setOneWayVsRoundTripData', {
          data: res.data.data.get,
          client: payload.client_name,
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getDeviceStatusData: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    const userGroups =
        rootGetters['account/getCurrentUser'].group_id &&
        rootGetters['account/getCurrentUser'].group_id[0];
    commit('setGraphLoadingState', { name: 'networkHealth', value: true });
    if (userGroups && userGroups !== 'all') {
      getScreensByGroup(user_groups)
        .then(response => {
          commit('setDeviceStatusData', {
            data: payload.data,
            rootState: payload.rootState,
            screensInfo: response.data.Items,
            validationScreens: payload.validationScreens,
          });
          commit('setGraphLoadingState', {
            name: 'networkHealth',
            value: false,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    } else {
      getAllScreenItems(payload.table_name)
        .then(response => {
          commit('setDeviceStatusData', {
            data: payload.data,
            rootState: payload.rootState,
            screensInfo: response.data.Items,
            validationScreens: payload.validationScreens,
          });
          commit('setGraphLoadingState', {
            name: 'networkHealth',
            value: false,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    }
  }),
  getScreenStatusData: async ({ commit, dispatch }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/screen?query=${encodeURIComponent(
        `{get(type_name: "screen", 
            sdate: ${payload.filterParams.sdate},
            edate: ${payload.filterParams.edate},
            screen: ${payload.filterParams.variables}, 
            filters: ${payload.filterParams.filterVariables}, 
            table_name:"${payload.table_name}",
            index: "${payload.filterParams.indexType}-index"
          ){
            uuid,
            status,
            launch_mode,
            session_status
          }}`
      )}`
    )
      .then(res => {
        dispatch('getDeviceStatusData', {
          filterParams: payload.filterParams,
          homeFilter: payload.homeFilter,
          table_name: payload.table_name,
          validationScreens: res.data.data.get,
        });
        commit('setScreenStatusData', {
          data: res.data.data.get,
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getAnalyticsScreens: async ({ dispatch }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/screen?query=${encodeURIComponent(
        `{get(type_name: "screen", 
            sdate: ${payload.filterParams.sdate},
            edate: ${payload.filterParams.edate},
            screen: ${payload.filterParams.variables}, 
            filters: ${payload.filterParams.filterVariables}, 
            table_name:"${payload.table_name}",
            index: "${payload.filterParams.indexType}-index"
          ){
            uuid,
            status,
            launch_mode,
            session_status
          }}`
      )}`
    )
      .then(res => {
        dispatch('getAnalyticsData', {
          filterParams: payload.filterParams,
          homeFilter: payload.homeFilter,
          table_name: payload.table_name,
          client: payload.client_name,
          screens: res.data.data.get,
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getRatingsData: async ({ commit }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/rating?query=${encodeURIComponent(
        `{get(type_name: "rating", 
            sdate: ${payload.filterParams.sdate},
            edate: ${payload.filterParams.edate},
            rating: ${payload.filterParams.variables}, 
            filters: ${payload.filterParams.filterVariables}, 
            table_name:"${payload.table_name}",
            index: "${payload.filterParams.indexType}-index"
          ){
            body, 
            session_id, 
            score, 
          }}`
      )}`
    )
      .then(res => {
        commit('setRatingsData', {
          data: res.data.data.get,
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getAnalyticsData: async ({ commit }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/analytic?query=${encodeURIComponent(
        `{get(type_name: "analytic", 
            sdate: ${payload.filterParams.sdate},
            edate: ${payload.filterParams.edate},
            analytic: ${payload.filterParams.variables}, 
            filters: ${payload.filterParams.filterVariables}, 
            table_name:"${payload.table_name}",
            index: "${payload.filterParams.indexType}-index"
          ){
            type
            screen_id,
            duration,
            description
          }}`
      )}`
    )
      .then(res => {
        commit('setAnalyticsData', {
          data: res.data.data.get,
          client: payload.client,
          screens: payload.screens,
        });
        commit('setGraphLoadingState', { name: 'appUsage', value: false });
        commit('setGraphLoadingState', {
          name: 'featureUsage',
          value: false,
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getHomeLocations: async ({ commit }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/coordinate?query=${encodeURIComponent(
        `{getPaginated(type_name: "coordinate", 
              sdate: ${payload.filterParams.sdate},
              edate: ${payload.filterParams.edate},
              coordinate: ${payload.filterParams.variables}, 
              filters: ${payload.filterParams.filterVariables},
              table_name:"${payload.table_name}",
              index: "${payload.filterParams.indexType}-index",
              pageSize: "1000"
            ){items{
              area_id, 
              group_id, 
              store_id, 
              screen_id, 
              session_id, 
              latitude, 
              longitude, 
              created_at, 
              timestamp, 
              error, 
              success
            }}}`
      )}`
    )
      .then(res => {
        commit('setDeviceLocations', res.data.data.getPaginated.items);
        commit('loading/setLoading', false, { root: true });
        resolve(res);
      })
      .catch(error => {
        commit('loading/setLoading', false, { root: true });
        reject(error);
      });
  }),
  getLaunchModeChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'launchModes', value: true });
    // const clientTable = rootGetters["account/getCurrentClient"].table_name;
    // const dates = createDateParam();
    // const { variables, index } = createFilterParam(filterParams, "screen");
    graphQL({
      query: `
        query {
          getLaunchModes(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables}){
            chartType
            showOnMobile
            type
            component
            width
            title
            data
            labels
            secondaryTitle
            options {
              colors
            }
          }
        }
      `,
    })
      .then(res => {
        res.data.data.getLaunchModes.type = 'bar-chart';
        res.data.data.getLaunchModes.chartType = 'bar';
        res.data.data.getLaunchModes.component = 'chart';
        res.data.data.getLaunchModes.data = [
          { data: res.data.data.getLaunchModes.data },
        ];
        Vue.set(state.userData.lineCharts, 1, res.data.data.getLaunchModes);
        commit('setGraphLoadingState', { name: 'launchModes', value: false });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getLaunchModeScreens: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'screensOverview', value: true });
    graphQL({
      query: `
        query {
          getLaunchModeGraph(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables}){
            chartType
            showOnMobile
            type
            component
            width
            title
            data
            labels
            secondaryTitle
            options {
              colors
            }
          }
        }
        `,
    })
      .then(res => {
        Vue.set(state.userData.homePage, 2, res.data.data.getLaunchModeGraph);
        commit('setGraphLoadingState', {
          name: 'screensOverview',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getNetworkHealthGraph: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'networkHealth', value: true });
    // const clientTable = rootGetters["account/getCurrentClient"].table_name;
    // const dates = createDateParam();
    // const { variables, index } = createFilterParam(filterParams, "screen");
    graphQL({
      query: `
        query {
          getNetworkHealthGraph(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables}){
            data
          }
        }
      `,
    })
      .then(res => {
        Vue.set(
          state.networkHealth.data,
          0,
          res.data.data.getNetworkHealthGraph.data[0]
        );
        Vue.set(
          state.networkHealth.data,
          1,
          res.data.data.getNetworkHealthGraph.data[1]
        );
        Vue.set(
          state.networkHealth.data,
          2,
          res.data.data.getNetworkHealthGraph.data[2]
        );
        commit('setGraphLoadingState', {
          name: 'networkHealth',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getRoundsPlayedChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'roundsPlayed', value: true });
    // const clientTable = rootGetters["account/getCurrentClient"].table_name;
    // const dates = createDateParam();
    // const { variables, index } = createFilterParam(filterParams, "screen");
    graphQL({
      query: `
        query {
          getRoundsPlayed(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables}){
            chartType
            showOnMobile
            type
            component
            width
            title
            data {
              data
            }
            labels
            secondaryTitle
            options {
              colors
            }
          }
        }
      `,
    })
      .then(res => {
        Vue.set(state.userData.lineCharts, 0, res.data.data.getRoundsPlayed);
        commit('setGraphLoadingState', {
          name: 'roundsPlayed',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getAnalyticsGraphs: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'appUsage', value: true });
    commit('setGraphLoadingState', { name: 'featureUsage', value: true });
    graphQL({
      query: `
        query {
          getAnalyticsGraphData(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables}){
            chart {
              chartType
              showOnMobile
              type
              component
              width
              title
              data {
                data
                name
              }
              labels
              secondaryTitle
              options {
                colors
              }
            }
            chartApp {
              chartType
              showOnMobile
              type
              component
              width
              title
              data {
                data
                name
              }
              labels
              secondaryTitle
              options {
                colors
              }
            }
          }
        }
      `,
    })
      .then(res => {
        commit('setAnalyticsGraphs', res.data.data.getAnalyticsGraphData);
        commit('setGraphLoadingState', { name: 'appUsage', value: false });
        commit('setGraphLoadingState', {
          name: 'featureUsage',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
};

// mutations
const mutations = {
  setAnalyticsGraphs(state, payload) {
    payload.chart.component = 'FeatureUsage';
    payload.chartApp.component = 'AppUsage';
    payload.chart.yAxis = state.yAxis;
    payload.chartApp.yAxis = state.yAxis;
    payload.chart.cardWidth = 'width:45.75%;';
    payload.chartApp.cardWidth = 'width:45.75%;';
    payload.chart.data[0].type = 'column';
    payload.chart.data[1].type = 'line';
    payload.chart.data[1].type = 'area';
    payload.chartApp.data[0].type = 'column';
    payload.chartApp.data[1].type = 'line';
    payload.chartApp.data[1].type = 'area';
    Vue.set(state.userData.homePage, 3, payload.chart);
    Vue.set(state.userData.homePage, 4, payload.chartApp);
  },
  setDeviceLocations(state, payload) {
    state.devices = [];
    state.devicesReady = false;
    payload.map(loc => {
      loc.lat = Number(loc.latitude);
      loc.lng = Number(loc.longitude);
      loc.infoOpen = false;
      loc.position = {
        lat: Number(loc.latitude),
        lng: Number(loc.longitude),
      };
      loc.id = loc.screen_id;
    });
    const deviceArray = [];
    const coords = [];
    payload.map(coord => {
      if (coord.created_at) {
        coords.push(coord);
      }
    });
    coords.sort((a, b) => b.created_at.toString().localeCompare(a.created_at.toString()));
    coords.map(device => {
      if (deviceArray.filter(e => e.id === device.id).length > 0) {
        device;
      } else {
        deviceArray.push(device);
      }
    });
    state.devicesReady = true;
    state.locations = deviceArray;
  },
  setDeviceStatusData(state, payload) {
    Vue.set(state.networkHealth.data, 0, 0);
    Vue.set(state.networkHealth.data, 1, 0);
    Vue.set(state.networkHealth.data, 2, 0);
    const checkScreens = [];
    payload.validationScreens.map(vScreen => {
      payload.screensInfo.map(screen => {
        if (screen.uuid === vScreen.uuid) {
          checkScreens.push(screen);
          if (screen.status === 'green') {
            Vue.set(
              state.networkHealth.data,
              0,
              state.networkHealth.data[0] + 1
            );
          } else if (screen.status === 'yellow') {
            Vue.set(
              state.networkHealth.data,
              1,
              state.networkHealth.data[1] + 1
            );
          } else if (screen.status === 'red') {
            Vue.set(
              state.networkHealth.data,
              2,
              state.networkHealth.data[2] + 1
            );
          } else if (!screen.status) {
            Vue.set(
              state.networkHealth.data,
              2,
              state.networkHealth.data[2] + 1
            );
          }
        }
      });
    });
    if (payload.validationScreens.length > checkScreens.length) {
      Vue.set(
        state.networkHealth.data,
        2,
        state.networkHealth.data[2] +
          (payload.validationScreens.length - checkScreens.length)
      );
    }
  },
  setCarOverview(state, payload) {
    Vue.set(state.carOverview.data, 0, 0);
    Vue.set(state.carOverview.data, 1, 0);
    state.carOverview.data = [payload.in_use, payload.idle];
    Vue.set(state.graphLoadingStates, 'carOverview', false);
  },
  setOneWayVsRoundTripData(state, payload) {
    let oneWay = 0;
    let roundTrip = 0;
    Vue.set(state.userData.homePage, 1, {
      component: 'OneWayRoundTrip',
      showOnMobile: null,
    });
    payload.data.map(session => {
      if (
        session.trip_type === 'ONE_WAY' ||
        session.trip_type === 'one way' ||
        session.trip_type === 'QR_CODE' ||
        session.trip_type === 'qr code' ||
        session.trip_type === 'bluetooth'
      ) {
        oneWay++;
      } else {
        roundTrip++;
      }
    });
    let oneWayName = '1-Way';
    let roundTripName = 'Round Trip';
    if (payload.client === 'bazzbi') {
      oneWayName = 'QR Code';
      roundTripName = 'Digital Key';
    } else if (payload.client === 'shark') {
      oneWayName = 'Bluetooth';
      roundTripName = 'Premium';
    }
    Vue.set(state.oneWayVsRoundTrip.data, 0, oneWay);
    Vue.set(state.oneWayVsRoundTrip.data, 1, roundTrip);
    Vue.set(state.oneWayVsRoundTrip.labels, 0, `${oneWay}: ${oneWayName}`);
    Vue.set(
      state.oneWayVsRoundTrip.labels,
      1,
      `${roundTrip}: ${roundTripName}`
    );
  },
  setScreenStatusData(state, payload) {
    const chartObject = {
      component: 'ScreensOverview',
      data: [],
      labels: ['Checked out', 'Checked in'],
      type: 'pie',
      title: 'Screens Overview',
      showOnMobile: null,
      secondaryTitle: '',
      options: { colors: ['#FFC103', '#ADADAD'] },
      overdue: 0,
    };
    let checkedIn = 0;
    let checkedOut = 0;
    let totalDevices = 0;
    const overdue = 0;
    payload.data.map(screen => {
      totalDevices++;
      if (screen.session_status === 'checked out') {
        checkedOut++;
      } else {
        checkedIn++;
      }
    });
    chartObject.data = [checkedOut, checkedIn];
    chartObject.overdue = overdue;
    chartObject.secondaryTitle = `Total Screens ${totalDevices}`;
    Vue.set(state.userData.homePage, 2, chartObject);
  },
  setRatingsData(state, payload) {
    let ratingAverage = 0;
    state.ratingData.total = 0;
    state.ratingData.votesPerRating = [
      { rating: 1, amount: 0 },
      { rating: 2, amount: 0 },
      { rating: 3, amount: 0 },
      { rating: 4, amount: 0 },
      { rating: 5, amount: 0 },
    ];
    payload.data.map(rating => {
      state.ratingData.total += 1;
      if (rating.score) {
        ratingAverage += rating.score;
        state.ratingData.votesPerRating[rating.score - 1].amount += 1;
      }
    });
    state.ratingData.avg = ratingAverage / state.ratingData.total;
  },
  setAnalyticsData(state, payload) {
    const chart = {};
    chart.chartType = 'line';
    chart.showOnMobile = null;
    chart.type = 'line-chart';
    chart.component = 'FeatureUsage';
    chart.yAxis = state.yAxis;
    chart.data = [
      {
        name: 'Total Clicks',
        type: 'column',
        data: [],
      },
      {
        name: 'Average Duration (Min)',
        type: 'line',
        data: [],
      },
      {
        name: 'Total Duration (Min)',
        type: 'area',
        data: [],
      },
    ];
    chart.title = 'Feature Usage';
    chart.labels = [];
    chart.options = { colors: ['#3787B7', '#FFC103', '#C3FEE4'] };
    const chartApp = {};
    chartApp.chartType = 'line';
    chartApp.showOnMobile = null;
    chartApp.type = 'line-chart';
    chartApp.component = 'AppUsage';
    chartApp.yAxis = JSON.parse(JSON.stringify(state.yAxis));
    chartApp.yAxis[0].labels.style.colors = '#000000';
    chartApp.yAxis[0].title.style.color = '#000000';
    chartApp.yAxis[0].axisBorder.color = '#000000';
    chartApp.data = [
      {
        name: 'Total Clicks',
        type: 'column',
        data: [],
      },
      {
        name: 'Average Duration (Min)',
        type: 'line',
        data: [],
      },
      {
        name: 'Total Duration (Min)',
        type: 'area',
        data: [],
      },
    ];
    chartApp.title = 'App Usage';
    chartApp.labels = [];
    chartApp.options = { colors: ['#000000', '#FFC103', '#C3FEE4'] };
    const {
      appLabels,
      appData,
      featureLabels,
      featureData,
    } = formatAnalyticSummary(payload);
    const newFeatureLabels = [];
    const newAppLabels = [];
    appLabels.map((label, index) => {
      chartApp.data[0].data[index] = appData[label.label].clicks;
      chartApp.data[2].data[index] = Math.round(appData[label.label].dur / 60);
      chartApp.data[1].data[index] = Math.round(
        appData[label.label].dur / appData[label.label].clicks / 60
      );
      label = label.label
        .split('_')
        .join(' ')
        .substring(0, 20);
      newAppLabels.push(label);
    });
    featureLabels.map((label, index) => {
      chart.data[0].data[index] = featureData[label.label].clicks;
      chart.data[2].data[index] = Math.round(featureData[label.label].dur / 60);
      chart.data[1].data[index] = Math.round(
        featureData[label.label].dur / featureData[label.label].clicks / 60
      );
      label = label.label
        .split('_')
        .join(' ')
        .substring(0, 20);
      newFeatureLabels.push(label);
    });
    for (let i = 0; i < newAppLabels.length; i += 1) {
      if (newAppLabels[i].includes('chive')) {
        newAppLabels[i] = newAppLabels[i]
          .replace('chive', 'atmosphere')
          .split('_')
          .join(' ')
          .substring(0, 20);
      }
    }
    for (let i = 0; i < newFeatureLabels.length; i += 1) {
      if (newFeatureLabels[i].includes('chive')) {
        newFeatureLabels[i] = newFeatureLabels[i]
          .replace('chive', 'atmosphere')
          .split('_')
          .join(' ')
          .substring(0, 20);
      }
    }
    chartApp.labels = newAppLabels;
    chart.labels = newFeatureLabels;
    if (payload.client === 'shark') {
      chart.cardWidth = 'width:45.75%;';
      chartApp.cardWidth = 'width:45.75%;';
    }
    Vue.set(state.userData.homePage, 3, chart);
    Vue.set(state.userData.homePage, 4, chartApp);
  },
  setLineGraphData(state, payload) {
    const chart = {};
    chart.chartType = 'line';
    chart.showOnMobile = true;
    chart.type = 'line-chart';
    chart.component = 'chart';
    chart.width = '100%';
    chart.title = 'Total Unique Rentals';
    chart.data = [
      {
        data: [],
        name: chart.title,
      },
      {
        data: [],
        name: chart.title,
      },
    ];
    if (!payload.filter.start_date) {
      payload.filter.start_date = moment()
        .startOf('isoWeek')
        .format('YYYY-MM-DD');
    }
    if (!payload.filter.end_date) {
      payload.filter.end_date = moment()
        .endOf('isoWeek')
        .format('YYYY-MM-DD');
    }
    if (payload.client === 'bazzbi') {
      chart.data[0].name = 'Digital Keys';
      chart.data[1].name = 'QR Codes';
    } else if (payload.client === 'avis') {
      chart.data[0].name = 'One Way';
      chart.data[1].name = 'Round Trip';
    } else if (payload.client === 'shark' || payload.client === 'shark2') {
      chart.title = 'Bluetooth Vs Premium';
      chart.data[0].name = 'Rounds';
      chart.data[1].name = '';
    }
    if (payload.type === 'cartData') {
      chart.data = [
        {
          data: [],
          name: 'Carts',
        },
      ];
    }
    let uniqueRounds = null;
    let consumerRevenue = null;
    if (payload.client === 'shark' && payload.type === 'unique') {
      uniqueRounds = JSON.parse(JSON.stringify(chart));
      uniqueRounds.title = 'Total Unique Rounds';
      uniqueRounds.data = [
        {
          data: [],
          name: chart.title,
        },
      ];
      consumerRevenue = JSON.parse(JSON.stringify(chart));
      consumerRevenue.title = 'Consumer Revenue';
      consumerRevenue.data = [
        {
          data: [],
          name: chart.title,
        },
      ];
    }
    const forecastedRevenue = JSON.parse(JSON.stringify(chart));
    if (payload.client === 'shark' || payload.client === 'shark2') {
      forecastedRevenue.title = 'Total Rounds';
      forecastedRevenue.data = [
        {
          data: [],
          name: 'Rounds',
        },
      ];
    }
    chart.labels = [];
    const newstart = moment(payload.filter.start_date);
    const newend = moment(payload.filter.end_date);
    const range = moment.range(newstart, newend);
    let format = 'YYYY';
    const years = Array.from(range.by('year'));
    let timeValues = years;
    let timeValue = 'y';
    if (years.length <= 2) {
      const months = Array.from(range.by('month'));
      timeValues = months;
      timeValue = 'M';
      format = 'MMMM';
      if (months.length <= 4) {
        const weeks = Array.from(range.by('week'));
        timeValues = weeks;
        timeValue = 'w';
        format = 'MM-DD';
        if (weeks.length <= 2) {
          const days = Array.from(range.by('day'));
          timeValues = days;
          timeValue = 'd';
          format = 'MM-DD';
          if (days.length <= 2) {
            const hours = Array.from(range.by('hour'));
            timeValues = hours;
            timeValue = 'h';
            format = 'HH:mm';
          }
        }
      }
    }
    const allRanges = [];
    timeValues.map((time, index) => {
      if (timeValues[index + 1]) {
        const range = moment.range(time, timeValues[index + 1]);
        allRanges.push(range);
      } else {
        const range = moment.range(time, moment(time).add(1, timeValue));
        allRanges.push(range);
      }
    });
    allRanges.map((range, index) => {
      chart.data[0].data[index] = 0;
      chart.data[1].data[index] = 0;
      if (payload.client === 'shark' && payload.type === 'unique') {
        uniqueRounds.data[0].data[index] = 0;
      }
      payload.data.data.get.map(session => {
        if (
          payload.type === 'unique' &&
          range.contains(moment(session.end_at * 1000))
        ) {
          if (payload.client === 'bazzbi') {
            chart.data[0].name = 'Digital Keys';
            chart.data[1].name = 'QR Codes';
            if (
              session.trip_type === 'qr_code' ||
              session.trip_type === 'qr code'
            ) {
              chart.data[1].data[index] += 1;
            } else {
              chart.data[0].data[index] += 1;
            }
          } else if (payload.client === 'avis') {
            chart.data[0].name = 'One Way';
            chart.data[1].name = 'Round Trip';
            if (
              session.trip_type === 'ONE_WAY' ||
              session.trip_type === 'one way'
            ) {
              chart.data[1].data[index] += 1;
            } else if (session.trip_type === 'round trip') {
              chart.data[0].data[index] += 1;
            }
          } else if (
            payload.client === 'shark' ||
            payload.client === 'shark2'
          ) {
            forecastedRevenue.data[0].data[index] += 1;
            chart.data[0].name = 'Bluetooth';
            chart.data[1].name = 'Premium';
            uniqueRounds.data[0].data[index] += 1;
            consumerRevenue.data[0].data[index] += 1;
            if (session.trip_type === 'bluetooth') {
              chart.data[0].data[index] += 1;
            } else {
              chart.data[1].data[index] += 1;
            }
          }
        }
        if (payload.type === 'forecastedDays') {
          let diff = 0;
          if (
            moment(session.expected_end_at * 1000).diff(range.end, 'days') > 0
          ) {
            diff = 30;
          } else if (
            moment(session.expected_end_at * 1000).diff(range.end, 'days') <
              0 &&
            range.contains(moment(session.start_at * 1000))
          ) {
            diff = moment(range.end).diff(
              session.expected_end_at * 1000,
              'days'
            );
          }
          if (payload.client === 'bazzbi') {
            chart.data[0].name = 'Digital Keys';
            chart.data[1].name = 'QR Codes';
            if (
              session.trip_type === 'qr_code' ||
              session.trip_type === 'qr code'
            ) {
              chart.data[1].data[index] += diff;
            } else {
              chart.data[0].data[index] += diff;
            }
          } else if (payload.client === 'avis') {
            chart.data[0].name = 'One Way';
            chart.data[1].name = 'Round Trip';
            if (
              session.trip_type === 'ONE_WAY' ||
              session.trip_type === 'one way'
            ) {
              chart.data[1].data[index] += diff;
            } else if (session.trip_type === 'round trip') {
              chart.data[0].data[index] += diff;
            }
          } else if (
            payload.client === 'shark' ||
            payload.client === 'shark2'
          ) {
            chart.data[0].data[index] += 1;
          }
        }
        if (
          payload.type === 'cartData' &&
          range.contains(moment.unix(session.last_activity))
        ) {
          chart.data[0].data[index] += 1;
        }
      });
    });
    const timeLabels = timeValues.map(m => m.format(format));
    if (forecastedRevenue.data[1]) {
      forecastedRevenue.title = 'Total Forecasted Revenue';
      forecastedRevenue.data[1].name = chart.data[1].name;
      forecastedRevenue.data[1].data = chart.data[1].data.map(
        item => item * 85
      );
      forecastedRevenue.data[0].name = chart.data[0].name;
      forecastedRevenue.data[0].data = chart.data[0].data.map(
        item => item * 85
      );
    }
    chart.labels = timeLabels;
    forecastedRevenue.labels = timeLabels;
    if (payload.type === 'forecastedDays') {
      if (payload.client !== 'shark') {
        chart.title = 'Forecasted Rental Days';
        Vue.set(state.userData.lineCharts, 1, chart);
        Vue.set(state.userData.lineCharts, 2, forecastedRevenue);
      }
    } else if (payload.client === 'shark') {
      consumerRevenue.data[0].data = chart.data[0].data.map(item => item * 85);
      uniqueRounds.labels = timeLabels;
      consumerRevenue.labels = timeLabels;
      chart.title = 'Bluetooth and Premium';
      chart.data[0].name = 'Bluetooth';
      chart.data[1].name = 'Premium';
      Vue.set(state.userData.lineCharts, 1, chart);
      Vue.set(state.userData.lineCharts, 0, uniqueRounds);
      Vue.set(state.userData.lineCharts, 3, consumerRevenue);
    } else {
      Vue.set(state.userData.lineCharts, 0, chart);
    }
  },
  setCartData(state, payload) {
    Vue.set(state.userData.lineCharts, 2, payload);
  },
  setUserDataLineCharts(state, payload) {
    state.userData.lineCharts = payload;
  },
  setGraphLoadingState(state, payload) {
    state.graphLoadingStates[payload.name] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
